import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'

import { RejectError } from '../../typings'

interface Payload {
  unifiedVehicle: uui.domain.client.UnifiedVehicle
  summary: uui.domain.ui.forms.VehicleFormChangesSummary
}

/**
 * Update Vehicle
 *
 * @private
 */
export const updateVehicle = createAsyncThunk<
  // Return type of the payload creator
  void,
  // First argument to the payload creator
  Payload,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/vehicle/update', async (payload, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()
    const result = await rpc('rpc/vehicle/update', {
      category: 'rpc',
      type: 'rpc/vehicle/update',
      unifiedVehicle: payload.unifiedVehicle,
      summary: payload.summary,
    })

    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: result.errorMessage,
        error: result,
      })
    }
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {createVehicleException}`,
      { tags: ['rpc', 'vehicles'], info: payload },
      'error',
    )
    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Create vehicle exception failed`,
      error,
    })
  }
})
